import { render, staticRenderFns } from "./PotensiDetailCarousel.vue?vue&type=template&id=0689497f&scoped=true"
import script from "./PotensiDetailCarousel.vue?vue&type=script&lang=js"
export * from "./PotensiDetailCarousel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0689497f",
  null
  
)

export default component.exports